import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useCustomEvent } from '@sloyd/ui';
import { bridge } from '@sloyd/viewer';
import { useEffect, useMemo, useState } from 'react';
import { invokeEvent } from 'shared-base';
import { ContentGeneratorDetails } from './ContentGeneratorDetails';

export type ContentGeneratorDetailsContainerProps = {
  id: string;
  onCta?: () => void;
};

export function ContentGeneratorDetailsContainer(props: ContentGeneratorDetailsContainerProps) {
  const dispatch = useDispatch();
  const palettes = useSelector(selectors.base.$palettes);
  const generators = useSelector(selectors.base.$generators);
  const [id, setId] = useState(props.id);
  const generator = generators.find((g) => g.id === id);

  useEffect(() => {
    dispatch(actions.currentIds.patch({ generatorId: id }));
  }, [id]);

  useCustomEvent('generator/change', (event) => {
    const { id } = event;
    setId(id);
  });

  const callbacks = useMemo(
    () => ({
      onOpenInPlayground: (id: string) => {
        invokeEvent('nav', { path: `/playground/generators/${id}` });
        props.onCta?.();
      },
      onRandomize: () => {
        // @ts-ignore
        const state = window.store.getState(); // HACK: to prevent re-renders
        const pack = selectors.single.$randomMaterialPack(state, Math.random());
        bridge.patchMaterials('main', pack);
      },
    }),
    []
  );

  return (
    <ContentGeneratorDetails generator={generator} palettes={palettes} callbacks={callbacks} />
  );
}

export default ContentGeneratorDetailsContainer;
